/**
 * Query Key factory for all radiology queries.
 *
 * @module Radiology
 */

import { Pagination } from "@customTypes/index";


export const radiologyQKeys = {
  all: () => ["radiology"] as const,

  allWithFilters: (filters: {
    pagination?: Partial<Pagination>;
    userId?: string;
  }) => [...radiologyQKeys.all(), { ...filters }] as const,

  patients: () => [...radiologyQKeys.all(), "patient"] as const,

  patient: (patientId: string) =>
    [...radiologyQKeys.patients(), patientId] as const,

  patientWithFilters: (
    patientId: string,
    filters: {
      pagination?: Partial<Pagination>;
      withFilesOnly?: boolean;
      fastConsultationOnly?: boolean;
      search?: string;
      status?: string;
      consultationId?: string;
    }
  ) => [...radiologyQKeys.patient(patientId), { ...filters }] as const,
};
